module.exports = __webpack_public_path__ + "img/festival_banner.c3bf2793.png";